import React, { FC } from 'react';

import { IImageMapAreaFront } from './models';

const ImageMapArea: FC<IImageMapAreaFront> = ({
  alt,
  shape,
  coords,
  activeState,
  tooltip,
  center,
  handleMouseEnter,
  handleMouseLeave,
  handleClick,
}) => {
  const activeSrc = activeState?.url;

  return (
    <>
      {activeSrc ? (
        <img
          className="image-map__area__hover"
          loading="lazy"
          aria-hidden="true"
          alt={alt}
          src={activeSrc}
        />
      ) : null}
      <area
        className="image-map__area"
        onMouseEnter={() => {
          handleMouseEnter(tooltip, center, activeSrc);
        }}
        onMouseLeave={handleMouseLeave}
        onFocus={() => {
          handleMouseEnter(tooltip, center, activeSrc);
        }}
        onBlur={handleMouseLeave}
        onClick={handleClick}
        onTouchStart={handleClick}
        href="#"
        shape={shape}
        coords={coords}
        alt={alt}
      />
    </>
  );
};

export default ImageMapArea;
